// extracted by mini-css-extract-plugin
export default {"main-input-toggle":"Toggle_main-input-toggle__1xQKd","switch":"Toggle_switch__Hm0Ua","slider":"Toggle_slider__Ew2zm","round":"Toggle_round__WToph"};